export default __webpack_public_path__ + "static/media/00_lesnik-min.251eeef7.jpg";